// src/lib/settingsSlugs.js
// URL slug ↔ settings menu/accordion for SettingsView + FinanceSettings (XOL-317).
// Top-level: slug === el-menu index. Keep in sync with the router regex in
// src/router/index.js and SETTINGS_TABS list below.
// Finance sub-sections: URL slug ↔ el-collapse item name. Only `agreements`
// diverges (el-collapse name is `table`, URL slug is `agreements`).

export const SETTINGS_TABS = [
  'orgs-towerco', 'orgs-telco', 'orgs-contractor', 'orgs-backhaul', 'orgs-landlord',
  'orgs-insurer', 'orgs-utility', 'orgs-authority', 'orgs-tower-supplier',
  'workflow', 'cats', 'loc', 'struct', 'finance', 'backup', 'logs'
]

// XOL-392: slugs that were renamed. Old slug -> current slug. The router's
// beforeEnter rewrites any key it finds in the URL, so existing bookmarks and
// deep links keep working instead of 404-ing. Old slugs must ALSO stay in the
// router's enum regex, or the route will not match and the guard never runs.
export const LEGACY_SETTINGS_SLUGS = {
  'orgs-xolas': 'orgs-towerco'
}

// XOL-392: slug -> the `category` string OrgTable filters the API with
// (`/org?filter=<category>`). Normally the slug IS the category with the
// `orgs-` prefix stripped, but `orgs-towerco` is a display rename only: the
// underlying org category is still the Xolas client one, so the filter value
// must NOT follow the slug. Renaming the URL is a UI concern; renaming what we
// ask the API for would return an empty table.
export const SETTINGS_SLUG_TO_CATEGORY = {
  'orgs-towerco': 'xolas'
}

// Finance sub-sections: URL slug ↔ el-collapse item name. Only `agreements` diverges.
export const FINANCE_SLUG_TO_INTERNAL = {
  settings: 'settings',
  agreements: 'table',
  audit: 'audit',
  rates: 'rates',
  builder: 'builder',
  bulk: 'bulk'
}

export const FINANCE_INTERNAL_TO_SLUG = Object.keys(FINANCE_SLUG_TO_INTERNAL)
  .reduce(function (acc, slug) { acc[FINANCE_SLUG_TO_INTERNAL[slug]] = slug; return acc }, {})
